import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PaymentService } from '../../../domain/service/payment/payment.service';
import { Payment } from '../../../domain/model/payment/payment.model';
import { NativeIoService } from '../../../core/native/native-io.service';

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.css']
})
export class PaymentHistoryComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dataSource = new MatTableDataSource<Payment>([]);
  displayedColumns: string[] = ['confirmationNumber', 'paymentDate', 'returns', 'totalPaid', 'status', 'actions'];

  loading = true;
  error: string | null = null;
  totalCount = 0;

  constructor(
    private paymentService: PaymentService,
    private router: Router,
    private nativeIo: NativeIoService
  ) { }

  ngOnInit(): void {
    this.loadPayments();
  }

  loadPayments(page: number = 0, pageSize: number = 20): void {
    this.loading = true;
    this.error = null;

    this.paymentService.getPaymentHistory(page, pageSize).subscribe({
      next: (history) => {
        this.dataSource.data = history.payments;
        this.totalCount = history.totalCount;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading payment history:', err);
        this.error = 'Failed to load payment history. Please try again.';
        this.loading = false;
      }
    });
  }

  viewDetails(payment: Payment): void {
    this.router.navigate(['/app/payments/confirmation', payment.confirmationNumber]);
  }

  downloadReceipt(paymentId: number, event: Event): void {
    event.stopPropagation();

    this.nativeIo.saveDownload(
      `payment-receipt-${paymentId}.pdf`,
      this.paymentService.receiptUrl(paymentId),
      this.paymentService.downloadReceipt(paymentId),
    ).catch((err) => console.error('Error downloading receipt:', err));
  }

  getStatusColor(status: string): string {
    switch (status?.toLowerCase()) {
      case 'completed':
        return 'green';
      case 'pending':
        return 'orange';
      case 'failed':
        return 'red';
      case 'refunded':
        return 'blue';
      default:
        return 'grey';
    }
  }

  getReturnsSummary(payment: Payment): string {
    if (!payment.returns || payment.returns.length === 0) return '';
    return payment.returns.map(r => r.period).join(', ');
  }
}
